import { BaseModel, Resource, Entry, EntryTypes, Form } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../resource/lea.resource';
import { jourTransform, jourOptions } from '../resource/select-options-static';
import { DateHelper } from '../helpers/date.helper';
import { Validators } from '@angular/forms';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/disponibilite',
            methods: LeaResource.methods,
        },
        'salle': {
            url: environment.proxyUrl + '/disponibiliteSalle',
            methods: LeaResource.methods,
        },
        'professeur': {
            url: environment.proxyUrl + '/disponibiliteProfesseur',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'create': {},
    'table': {},
})
export class DisponibiliteModel extends BaseModel {

    @Entry({
        'table': {
            hidden: true
        },
        'create': {
            hidden: true
        }
    })
    _explicitType: string = 'Disponibilite';

    @Entry({
        base: {
            hidden: true,
        },
        'table': {},
        'create': {},
    })
    id: string;

    @Entry({
        'table': {
            hidden: true
        },
        'create': {
            hidden: true
        }
    })
    foreignKey: string;

    @Entry({
        'table': {
            hidden: true
        },
        'create': {
            hidden: true
        }
    })
    anneeScolaire: number;

    @Entry({
        'table': {
            label: 'Jour',
            flexGrow: 2,
            transform: jourTransform,
        },
        'create': {
            type: EntryTypes.SELECT,
            label: 'Jour',
            css: {
                group: 'col-xs-12',
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            options: jourOptions,
        }
    })
    jour: number;
    jourLibelle: string;

    @Entry({
        'table': {
            label: 'Heure début',
            flexGrow: 1,
            transform: (value) => DateHelper.minutesToHoursMin(value),
        },
        'create': {
            type: EntryTypes.TIME,
            label: 'Début',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            format: 'minutes',
            validators: [Validators.required],
            validatorsMsgs: {'required': 'L\'horaire de début est obligatoire'},
        }
    })
    horaireDebut: string;

    @Entry({
        'table': {
            label: 'Heure fin',
            flexGrow: 1,
            transform: (value) => DateHelper.minutesToHoursMin(value),
        },
        'create': {
            type: EntryTypes.TIME,
            label: 'Fin',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            format: 'minutes',
            validators: [Validators.required],
            validatorsMsgs: {'required': 'L\'horaire de fin est obligatoire'},
        }
    })
    horaireFin: string;

    constructor(data?) {
        super();
        Object.assign(this, data);
        this.jour = data && data.jour ? +data.jour : null;
    }
}




// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/disponibilite/disponibilite.model.ts